import {Component, OnDestroy, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from '@node_modules/rxjs/BehaviorSubject';
import {EventEmitter, Input} from '@node_modules/@angular/core';
import {Program} from '@models/program';
import {User} from '@models/user';
import {StudentService} from "@services/student/student.service";

@Component({
  selector: 'app-list-members',
  templateUrl: './list-members.component.html',
  styleUrls: ['./list-members.component.scss']
})
export class ListMembersComponent implements OnInit, OnDestroy {
  @Input() add_text = 'Add Students';
  @Input() showCreateButton = true;
  @Input() programs: Program[];
  @Input() setInvitedGetted: BehaviorSubject<boolean>;
  @Input() onLoadingNewMembers: BehaviorSubject<boolean>;
  @Input() setMembersSearches: BehaviorSubject<User[]>;
  @Input() setMembers: BehaviorSubject<User[]>;
  @Output() openCreateModal =  new EventEmitter<boolean>();
  @Output() currentMember =  new EventEmitter<User>();

  memberes: User[];
  searchMembers: User[];
  invitedGetted: true;
  newMembersAreLoading = false;
  page: number;
  subscribes = [];

  constructor(
      private studentService: StudentService,
  ) { }

  ngOnInit() {
    // this.subscribes.push(
    //   this.setInvitedGetted.subscribe(
    //     resp => {
    //       this.invitedGetted = resp;
    //     }
    //   ));
    this.subscribes.push(
      this.setMembersSearches.subscribe(
        resp => {
          this.searchMembers = resp;
        }
      ));
    if (this.onLoadingNewMembers) {
      this.subscribes.push(
        this.onLoadingNewMembers.subscribe(
          resp => {
            this.newMembersAreLoading = resp;
          }
        ));
    }
    this.subscribes.push(
      this.setMembers.subscribe(
        resp => {
          this.memberes = resp;
        }
      ));
    if (localStorage.getItem('openUserProfile')) {
      const student = JSON.parse(localStorage.getItem('openUserProfile'));
      this.setCurrentMember(student);
      localStorage.removeItem('openUserProfile');
    }
  }
  ngOnDestroy() {
    this.unsubscribe();
  }
  openCreateModalAction() {
    this.openCreateModal.emit(true);
  }
  unsubscribe() {
    this.subscribes.map( subscr => {
      subscr.unsubscribe();
    });
  }
  setCurrentMember(member) {
    this.currentMember.next(member);
  }
}
